import classNames from 'classnames';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import ReactSelect from 'react-select';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';

const ADScheduleDonations = () => {
  const [date, setDate] = useState(null);
  const [timeTableData, setTimeTableData] = useState(null);
  const [splits, setSplits] = useState(null);
  const [tz, setTz] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  const timeTableOptions = [
    { value: '1', label: 'Last 5 Night (Ramadan)' },
    { value: '2', label: 'Last 10 Night (Ramadan)' },
    { value: '3', label: 'Last 15 Night (Ramadan)' },
    { value: '4', label: 'Full (Ramadan)' }
  ];
  const splitsOptions = [
    { value: '1', label: 'Last 5 Night (Ramadan)' },
    { value: '2', label: 'Last 10 Night (Ramadan)' },
    { value: '3', label: 'Last 15 Night (Ramadan)' },
    { value: '4', label: 'Full (Ramadan)' }
  ];

  const scheduleList = [
    { id: 1, date: '11/03', amount: '$25.00', selected: true },
    { id: 2, date: '11/03', amount: '$25.00' },
    { id: 3, date: '11/03', amount: '$25.00' },
    { id: 4, date: '11/02', amount: '$25.00' },
    { id: 5, date: '11/03', amount: '$25.00', selected: true },
    { id: 6, date: '11/04', amount: '$50.00' },
    { id: 7, date: '11/05', amount: '$25.00' },
    { id: 8, date: '11/03', amount: '$125.00' },
    { id: 9, date: '11/03', amount: '$15.00' }
  ];

  return (
    <Card className="mb-3">
      <FalconCardHeader
        title={<h5 className="mt-2 fw-medium">Schedule Donations</h5>}
        light={false}
        titleTag="div"
        menuClassName="align-items-center"
        endEl={
          <Form.Check
            type="switch"
            id="checkedSwitch"
            label=""
            defaultChecked
          />
        }
      />
      <Card.Body className="pb-1">
        <Row>
          <Form.Group as={Col} md={6} className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <DatePicker
              selected={date}
              onChange={date => setDate(date)}
              className="form-control"
              placeholderText="DD/MM/YYYY"
              timeIntervals={5}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              fixedHeight
            />
          </Form.Group>
          <Form.Group as={Col} md={6} className="mb-3">
            <Form.Label>Time Zone</Form.Label>
            <TimezoneSelect
              value={tz}
              onChange={setTz}
              labelStyle="original"
              onMenuScrollToTop
              menuPosition="fixed"
              timezones={{
                ...allTimezones,
                'America/Lima': 'Pittsburgh',
                'Europe/Berlin': 'Frankfurt'
              }}
            />
          </Form.Group>
          <Form.Group as={Col} md={6} className="mb-3 mb-md-0">
            <Form.Label>TimeTable</Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={timeTableOptions}
              placeholder="Select"
              classNamePrefix="react-select"
              value={timeTableData}
              onChange={value => setTimeTableData(value)}
              menuPosition="fixed"
            />
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>Splits</Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={splitsOptions}
              placeholder="Select"
              classNamePrefix="react-select"
              value={splits}
              onChange={value => setSplits(value)}
              menuPosition="fixed"
            />
          </Form.Group>
        </Row>
        <hr />

        <div>
          <Flex className="mb-3" justifyContent={'between'}>
            <p className="fs-1 mb-0 fw-medium">Schedule Preview</p>
            <IconButton
              icon={'pen'}
              iconClassName="me-2"
              variant="link"
              className="p-0"
            >
              Edit
            </IconButton>
          </Flex>
          <Flex className={'flex-wrap'}>
            {scheduleList?.map(item => (
              <div
                key={item.id}
                className={classNames('schedule-list', {
                  selected: item.selected
                })}
              >
                <p className="mb-0 fw-bold">{item.date}</p>
                <p className="mb-0 fw-semi-bold">{item.amount}</p>
              </div>
            ))}
          </Flex>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ADScheduleDonations;
